export default {
  rankOrder: {
    ariaAddOption: 'Aggiungi {label} alla lista classificata',
    ariaMoveUp: 'Sposta {label} su',
    ariaMoveDown: 'Sposta {label} giù',
    ariaRemoveOption: 'Rimuovi {label} dalla lista classificata',
  },
  coe: {
    ariaDisclaimer: 'Avviso',
    ariaQuestion: 'Domanda',
    ariaConversationHistory: 'Cronologia conversazione',
    ariaYourResponse: 'La tua risposta {number}',
    ariaFollowUpQuestion: 'Domanda di follow-up {number}',
    ariaResponseInput: 'Campo di risposta',
    ariaRespondingTo: 'Rispondendo a',
    ariaSendResponse: 'Invia risposta',
    ariaThinking: 'In elaborazione'
  },
  deviceView: {
    toolbar: 'Dispositivo di anteprima',
    mobile: 'Mobile',
    tablet: 'Tablet',
    desktop: 'Desktop'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'Logo QuestDIY'
  }
}
